/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionmeetingdate2Inputs */

const de__field_acquisitionmeetingdate2 = /** @type {(inputs: _Field_Acquisitionmeetingdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akquisegespräch-Datum`)
};

/**

* @param {_Field_Acquisitionmeetingdate2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionmeetingdate2 = /** @type {((inputs?: _Field_Acquisitionmeetingdate2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionmeetingdate2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionmeetingdate2(inputs)
});
export { _field_acquisitionmeetingdate2 as "_field_acquisitionMeetingDate" }